<div class="ticker">
  <div class="ticker-t" id="tt">
    @for (item of tickerItems; track $index) {
      <div class="ti">
        <span>{{ item.title }}</span>
        <span class="ti-r">{{ item.rate }}</span>
        <span>{{ item.apr }}</span>
        @if (item.up) {
          <span class="ti-up">▲</span>
        }
      </div>
    }
    @for (item of tickerItems; track $index) {
      <div class="ti">
        <span>{{ item.title }}</span>
        <span class="ti-r">{{ item.rate }}</span>
        <span>{{ item.apr }}</span>
        @if (item.up) {
          <span class="ti-up">▲</span>
        }
      </div>
    }
  </div>
</div>